import { Box, Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledCheckbox, ControlledTextField } from 'components/common'
import { Mode } from 'constants/index'
import { CreateAndUpdateCancellationOrLostReasonDtoInput } from 'generated/graphql'

interface IProps {
  mode: number | undefined
}

const CancellationOrLostReasonsForm = ({ mode = Mode.Create }: IProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateAndUpdateCancellationOrLostReasonDtoInput>()

  return (
    <Box pt={1}>
      <Grid container columnSpacing={3} rowSpacing={1.5}>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            label='Name'
            name='name'
            required
            disabled={mode === Mode.Update}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            label='Code'
            name='code'
            error={!!errors.code}
            helperText={errors.code?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledCheckbox
            control={control}
            name='isActive'
            label='Is Active'
            size='small'
            defaultValue={true}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default CancellationOrLostReasonsForm
